import {
  Box, ClickAwayListener, Drawer, Grid, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Pagination, PaginationItem, Slide, Tooltip, Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { CloseIcon, styled } from "../../styles/MaterialUI";
import axios from "axios";
import { INSIGHTS_URL } from "../../constants/apiConstants";
import { useDispatch, useSelector } from "react-redux";

import SelectedMenuIcon from '../../assets/MenuIcons/SelectedMenuIcon.svg';
import ExecutiveIcon from '../../assets/MenuIcons/ExecutiveIcon.svg';
import FinanceIcon from '../../assets/MenuIcons/FinanceIcon.svg';
import ForecastIcon from '../../assets/MenuIcons/ForecastIcon.svg';
import InventoryIcon from '../../assets/MenuIcons/InventoryIcon.svg';
import PayrollIcon from '../../assets/MenuIcons/PayrollIcon.svg';
import ProductionIcon from '../../assets/MenuIcons/ProductionIcon.svg';
import ProjectsIcon from '../../assets/MenuIcons/ProjectsIcon.svg';
import PurchasingIcon from '../../assets/MenuIcons/PurchasingIcon.svg';
import QualityIcon from '../../assets/MenuIcons/QualityIcon.svg';
import SalesIcon from '../../assets/MenuIcons/SalesIcon.svg';
import SalesTeamIcon from '../../assets/MenuIcons/SalesTeamIcon.svg';
import SLXCRMIcon from '../../assets/MenuIcons/SLXCRMIcon.svg';
import AdminIcon from '../../assets/MenuIcons/AdminIcon.svg';
import ServicesIcon from '../../assets/MenuIcons/ServicesIcon.svg';
import MachinesIcon from '../../assets/MenuIcons/MachinesIcon.svg';
import { showAlertPopup } from "../Redux/Features/showAlertSlice";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import SearchViewsIcon from '../../assets/CustomIcons/SearchViewsIcon.svg';
import ShowHideToggle from "./ShowHideToggle";

import { Dialog } from "@mui/material";

// Set default props because unable to type in the TextField inside the MegaMenu.
Dialog.defaultProps = {
  disableEnforceFocus: true,
  disableRestoreFocus: true,
  disableAutoFocus: true,
};

const listText = { marginTop: 1, marginBottom: 1, fontSize: "13px", color: 'white', fontWeight: 'normal', paddingLeft: "12px" }

const StyledSearchBox = styled("div")(() => ({
  display: 'flex', alignItems: 'center', backgroundColor: '#ffffff', borderRadius: 50, padding: '0 10px', width: '300px', boxSizing: 'border-box', border: 'none'
}));

const MegaMenu = ({ openDrawer, onClose }) => {
  const { userToken } = useSelector((state) => state.userToken);
  const [rawData, setRawData] = useState(null);
  const [moduleName, setModuleName] = useState([]);
  const [selectedModule, setSelectedModule] = useState("");
  const [openSidePanel, setOpenSidePanel] = useState(false);
  const [workbookData, setWorkBookData] = useState([]);
  const [state, setState] = useState({ sidePanelWidth: 0, sidePanelPadding: 0 });
  const [isDrawerOpened, setIsDrawerOpened] = useState(false);
  const containerRef = useRef(null);
  const [itemsPerPage, setItemsPerPage] = useState(1);
  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [userSettings, setUserSettings] = useState({});
  const [tooltip, setTooltip] = useState({ visible: false, text: "", x: 0, y: 0 });

  // Default: "Yes" (true)
  const showHidden = true;

  const headers = { Authorization: `Bearer ${userToken}` };
  const dispatch = useDispatch();

  useEffect(() => {
    setIsDrawerOpened(openDrawer);
  }, [openDrawer]);

  const handleMouseLeave = () => {
    setTooltip((t) => ({ ...t, text: "", visible: false }));
  }

  const handleClose = (workbook_object) => {
    if (workbook_object) {
      onClose(selectedModule, workbook_object);
    }
    setState((prevState) => ({ ...prevState, sidePanelWidth: 0, sidePanelPadding: 0 }));
    setOpenSidePanel(false);
    setSelectedModule("");
    setIsDrawerOpened(false);
    setSearchQuery("");
  };
  const dummyFunction = () => { };

  useEffect(() => {
    const settings = userSettings ?? {};
    const childMenu = workbookData[0];
    if (!settings || !Array.isArray(childMenu) || childMenu.length === 0) return;

    const hiddenGroups = userSettings?.hidden_wb_groups ?? [];
    const hiddenWorkbooks = userSettings?.hidden_workbooks ?? [];
    const updatedMenu = childMenu.map((g) => ({
      ...g,
      hidden_by_user: hiddenGroups.includes(g.md_wb_group_id),
      SAN_Modules_WBGroup_Workbooks: Array.isArray(g.SAN_Modules_WBGroup_Workbooks)
        ? g.SAN_Modules_WBGroup_Workbooks.map((w) => ({
          ...w,
          hidden_by_user: hiddenWorkbooks.includes(w.workbook_id),
        }))
        : [],
    }));

    setWorkBookData(updatedMenu);
  }, [selectedModule]);

  let hidden_workbooks = {}
  let editStateWorkbooks = []
  let org_hid_wrkbooks = Object.keys(hidden_workbooks)
  let workbookKeys = [...org_hid_wrkbooks, ...editStateWorkbooks]

  const handleModuleClick = (module_Name, event) => {
    const moduleData = rawData
      .map((module) => module.SAN_Modules_WBGroups)
      .filter((d) => d[0].module_title === module_Name);

    setState((prevState) => ({ ...prevState, sidePanelWidth: '100vw', sidePanelPadding: '175px' }));
    setSelectedModule(module_Name);
    setWorkBookData(moduleData);
    setOpenSidePanel(true);
    event.stopPropagation();
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(`${INSIGHTS_URL.CAST_API_URL}userDbList`, {}, { headers });
        const { data, user_settings } = response.data;
        const moduleNames = data.map((module) => module.SAN_Modules_WBGroups).map((d) => d[0].module_title);

        setRawData(data);
        setModuleName(moduleNames);
        setUserSettings(user_settings);
      } catch (error) {
        const { statusCode, message, redirect_url } = error.response.data;
        dispatch(showAlertPopup({ isOpen: true, severity: "error", message: message }));
        if (statusCode === 403) {
          window.open(redirect_url, "_self");
        }
      }
    };

    fetchData();
  }, []);

  // --- Get visible child menu ---
  const getVisibleChildMenu = (menugroup) => {
    const isGroupHidden = menugroup.hidden_by_admin || menugroup.hidden_by_user;

    if (!showHidden && isGroupHidden) return [];

    return menugroup.SAN_Modules_WBGroup_Workbooks.filter((workbook) => {
      const isWorkbookHidden = workbook.hidden_by_admin || workbook.hidden_by_user;
      return showHidden || !isWorkbookHidden;
    });
  };

  const hiddenGroups = userSettings?.hidden_wb_groups ?? [];
  const hiddenWorkbooks = userSettings?.hidden_workbooks ?? [];

  // Jump to page containing first match
  useEffect(() => {
    if (searchQuery) {
      setPage(1); // or calculate page of first match if needed
    }
  }, [searchQuery]);

  // Ensure state.childMenu is an array
  // Filtered child menu
  const filteredChildMenu = workbookData
    ? workbookData
      .map((menugroup) => {
        const filteredWorkbooks = Array.isArray(menugroup.SAN_Modules_WBGroup_Workbooks)
          ? menugroup.SAN_Modules_WBGroup_Workbooks.filter(
            (wb) => wb.workbook_title.toLowerCase().includes(searchQuery)
          )
          : [];

        return filteredWorkbooks.length > 0
          ? { ...menugroup, SAN_Modules_WBGroup_Workbooks: filteredWorkbooks }
          : null;
      })
      .filter(Boolean)
    : [];

  // --- Apply hidden-workbook filtering dynamically ---
  const applyHiddenFilter = (menuData, showHidden) => {
    return menuData
      .map((menugroup) => {
        const groupIsHidden = hiddenGroups.includes(menugroup.md_wb_group_id);
        let workbooks = menugroup.SAN_Modules_WBGroup_Workbooks || [];

        if (!showHidden) {
          if (groupIsHidden) return null;
          workbooks = workbooks.filter(
            wb => !hiddenWorkbooks.includes(wb.workbook_id)
          );
        }

        return workbooks.length > 0
          ? { ...menugroup, SAN_Modules_WBGroup_Workbooks: workbooks }
          : null;
      })
      .filter(Boolean);
  };

  // Apply hidden filtering AFTER search filtering
  const visibleChildMenu = applyHiddenFilter(filteredChildMenu, showHidden);

  // --- Pagination should be based on visibleChildMenu ---
  const paginationDataConverted = visibleChildMenu.length > 0
    ? Array.from(
      { length: Math.ceil(visibleChildMenu.length / itemsPerPage) },
      (_, i) => visibleChildMenu.slice(i * itemsPerPage, i * itemsPerPage + itemsPerPage)
    )
    : []

  useEffect(() => {
    if (searchQuery?.length > 0) {
      // Filter childMenu to find first match
      const allMenus = Array.isArray(workbookData) ? workbookData : [];

      const filtered = allMenus
        .map((menugroup) => {
          const filteredWorkbooks = Array.isArray(menugroup.SAN_Modules_WBGroup_Workbooks)
            ? menugroup.SAN_Modules_WBGroup_Workbooks.filter((childMenu) =>
              childMenu.workbook_title.toLowerCase().includes(searchQuery)
            )
            : [];
          return filteredWorkbooks.length > 0
            ? { ...menugroup, SAN_Modules_WBGroup_Workbooks: filteredWorkbooks }
            : null;
        })
        .filter(Boolean);

      const firstMatchIndex = filtered.findIndex(
        (menugroup) => menugroup.SAN_Modules_WBGroup_Workbooks.length > 0
      );

      if (firstMatchIndex >= 0) {
        const newPage = Math.floor(firstMatchIndex / itemsPerPage) + 1;
        setPage(newPage);
      } else {
        setPage(1);
      }
    } else {
      setPage(1); // reset page when search cleared
    }
  }, [searchQuery]); // ONLY run when searchQuery changes

  // Render current page safely
  const currentPageData = paginationDataConverted[page - 1] || [];

  // Page change handler
  const handlePageChange = (_, value) => {
    setPage(value);
  };

  // Count total and visible workbooks dynamically
  const totalWorkbooks = workbookData
    ? workbookData.reduce(
      (sum, group) => sum + (Array.isArray(group.SAN_Modules_WBGroup_Workbooks) ? group.SAN_Modules_WBGroup_Workbooks.length : 0),
      0
    ) : 0;

  // Count total  hidden workbooks
  // --- Compute total hidden workbook count (ALL WORKBOOKS) ---
  const totalHiddenWorkbooksCount = (workbookData || []).reduce((acc, menugroup) => {
    const workbooks = menugroup.SAN_Modules_WBGroup_Workbooks || [];
    const groupIsHidden = hiddenGroups.includes(menugroup.md_wb_group_id);

    if (groupIsHidden) {
      // If entire group is hidden, all its workbooks count as hidden
      return acc + workbooks.length;
    }

    // Otherwise, only hidden workbooks in visible groups
    const hiddenInGroup = workbooks.filter(wb =>
      hiddenWorkbooks.includes(wb.workbook_id)
    ).length;

    return acc + hiddenInGroup;
  }, 0);

  // Function to filter workbooks depending on ShowHidden
  const getFilteredWorkbooks = (currentPageData, showHidden) => {
    return currentPageData.reduce((total, menugroup) => {
      const workbooks = menugroup.SAN_Modules_WBGroup_Workbooks || [];
      const groupIsHidden = hiddenGroups.includes(menugroup.md_wb_group_id);

      let visibleWorkbooks = 0;

      if (showHidden) {
        // include everything (even hidden)
        visibleWorkbooks = workbooks.length;
      } else {
        // exclude hidden groups & hidden workbooks
        if (!groupIsHidden) {
          visibleWorkbooks = workbooks.filter(
            wb => !hiddenWorkbooks.includes(wb.workbook_id)
          ).length;
        }
      }

      return total + visibleWorkbooks;
    }, 0);
  };

  // Apply filtering based on ShowHidden
  const filteredWorkbooksOnPage = getFilteredWorkbooks(currentPageData, showHidden);

  useEffect(() => {
    if (!containerRef.current) return;

    const observer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const containerWidth = entry.contentRect.width;
        const itemWidth = 160; // width per item
        const newItemsPerPage = Math.max(1, Math.floor(containerWidth / itemWidth));
        setItemsPerPage(prev => {
          if (prev !== newItemsPerPage) {
            // Only reset page if number of items per page changed
            setPage(1);
          }
          return newItemsPerPage;
        });
      }
    });

    observer.observe(containerRef.current);

    return () => observer.disconnect();
  }, [filteredWorkbooksOnPage, workbookData]);

  useEffect(() => {
    if (!containerRef.current) return;

    if (filteredWorkbooksOnPage === 0) {
      setPage(1);
    }
  }, [filteredWorkbooksOnPage]);

  const moduleList = (
    <Box role="presentation"
      sx={{
        display: "flex", flexDirection: "column", width: 180, backgroundColor: "#13273E", height: "100vh", color: "#fff",
      }}
    >
      <List sx={{ mt: 1 }}>
        {moduleName.map((text) => (
          <ListItem key={text} disablePadding sx={{ display: 'block', color: "#B5B7B7", padding: "1px 6px", mb: 0.5 }}
            secondaryAction={
              text === selectedModule ?
                <img src={SelectedMenuIcon} alt="Selected Menu Icon" style={{ width: 5, height: 21, marginTop: "7px" }} /> : null
            }
          >
            <ListItemButton selected={text === selectedModule} onClick={(e) => handleModuleClick(text, e)}
              sx={{
                borderRadius: 50, padding: "2px 6px", px: 2,
                '&:hover': {
                  backgroundColor: '#fff5eb !important', color: '#ff8000',
                },
                '&.Mui-selected': {
                  backgroundColor: '#ff8000 !important', color: '#FFFFFF',
                  '& img': {
                    filter: 'brightness(0) invert(1)', transition: 'filter 0.3s ease',
                  },
                },
                justifyContent: 'initial'
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0, mr: '8px', width: 'auto', height: 32, display: 'flex',
                  justifyContent: 'center', alignItems: 'center', borderRadius: 50, transition: 'all 0.3s ease-in-out',
                }}
              >
                {text === "Executive" ? <img src={ExecutiveIcon} alt="Executive Icon" style={{ width: 18, height: 18 }} />
                  : text === "Finance" ? <img src={FinanceIcon} alt="Finance Icon" style={{ width: 18, height: 18 }} />
                    : text === "Forecast" ? <img src={ForecastIcon} alt="Forecast Icon" style={{ width: 18, height: 18 }} />
                      : text === "Inventory" ? <img src={InventoryIcon} alt="Inventory Icon" style={{ width: 18, height: 18 }} />
                        : text === "Payroll" ? <img src={PayrollIcon} alt="Payroll Icon" style={{ width: 18, height: 18 }} />
                          : text === "Machines" ? <img src={MachinesIcon} alt="Machines Icon" style={{ width: 18, height: 18 }} />
                            : text === "Production" ? <img src={ProductionIcon} alt="Production Icon" style={{ width: 18, height: 18 }} />
                              : text === "Projects" ? <img src={ProjectsIcon} alt="Projects Icon" style={{ width: 18, height: 18 }} />
                                : text === "Purchasing" ? <img src={PurchasingIcon} alt="Purchasing Icon" style={{ width: 18, height: 18 }} />
                                  : text === "Quality" ? <img src={QualityIcon} alt="Quality Icon" style={{ width: 18, height: 18 }} />
                                    : text === "Sales" ? <img src={SalesIcon} alt="Sales Icon" style={{ width: 18, height: 18 }} />
                                      : text === "Services" ? <img src={ServicesIcon} alt="Services Icon" style={{ width: 18, height: 18 }} />
                                        : text === "Admin" ? <img src={AdminIcon} alt="Admin Icon" style={{ width: 18, height: 18 }} />
                                          : text === "SLX CRM" ? <img src={SLXCRMIcon} alt="SlxCrm Icon" style={{ width: 18, height: 18 }} />
                                            : text === "Sales Team" ? <img src={SalesTeamIcon} alt="SalesTeam Icon" style={{ width: 18, height: 18 }} />
                                              : <img src={AdminIcon} alt="Other Icon" style={{ width: 18, height: 18 }} />
                }
              </ListItemIcon>
              <ListItemText primary={text} primaryTypographyProps={{ fontSize: "13px" }} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <>
      <Drawer
        open={isDrawerOpened}
        onClose={onClose}
        variant="permanent"
        ModalProps={{ keepMounted: true, BackdropProps: { invisible: true } }}
        PaperProps={{
          sx: {
            height: "calc(100% - 50px)", top: 50, display: isDrawerOpened ? "flex" : "none", boxSizing: "border-box",
            borderRightColor: "#13273E", zIndex: 10, transition: 'width 0.3s cubic-bezier(0.4, 0.0, 0.2, 1)',
          },
        }}
      >
        {moduleList}
      </Drawer>

      {/* Mega Menu */}
      <ClickAwayListener onClickAway={state.sidePanelWidth > 0 ? handleClose : dummyFunction}>
        <Slide in={openSidePanel} direction="right">
          <Grid ref={containerRef} container id="mySidebar" sx={{
            width: `calc(100% - ${state.sidePanelPadding})`, left: state.sidePanelWidth !== 0 ? state.sidePanelPadding : 0,
            backgroundColor: '#13273E', color: 'white', height: 'calc(100% - 60px)', position: 'absolute', zIndex: 9, top: "60px",
            overflow: 'hidden', scrollbarWidth: "thin", scrollbarColor: " #ff8000 #13273E", paddingTop: 0,
          }}
            onMouseLeave={handleClose}
          >
            <Grid item xs={12} sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px", flexWrap: "wrap" }}>
              <Box display="flex" alignItems="center" flexDirection="column" sx={{ gap: "2px" }}>
                <Pagination size="small" sx={{
                  alignSelf: "flex-start",
                  border: "1px solid #ffffff1f", borderRadius: 50, padding: "3px 4px",
                  "& .MuiPaginationItem-root": { color: "#ffffff", "&:hover": { backgroundColor: "#fff5eb", color: "#ff8000" } },  // Numbers default white
                  "& .MuiPaginationItem-root.Mui-selected": { backgroundColor: "#ff8000", color: "#ffffff", "&:hover": { backgroundColor: "#ff8000", color: "#ffffff" } },  // Selected number
                  "& .MuiPaginationItem-previousNext": { backgroundColor: "#ffffff", color: "#000000", "&:hover": { backgroundColor: "#ffffff", color: "#000000" } },  // Previous-next arrow
                  "& .MuiPaginationItem-ellipsis": { backgroundColor: "transparent !important", color: "#ffffff", "&:hover": { color: "#ffffff" } },  // Ellipsis (...) disable hover
                  "& .MuiPagination-ul": { display: "flex", gap: "2px" }
                }}
                  count={paginationDataConverted.length}
                  page={page}
                  onChange={handlePageChange}
                  renderItem={(item) => (
                    <PaginationItem
                      slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                      {...item}
                    />
                  )}
                />
                <Typography variant="caption" sx={{ fontSize: "10px", color: "#89939F", alignSelf: "flex-start", marginLeft: "4px" }}>{`Viewing ${filteredWorkbooksOnPage} of ${totalWorkbooks} Workbooks`}</Typography>
              </Box>
              <Box display="flex" alignItems="center" gap={5} alignSelf="flex-start">
                <StyledSearchBox>
                  <img src={SearchViewsIcon} alt="Search Icon"
                    style={{ width: '16px', height: '16px', marginRight: '8px', objectFit: 'cover' }}
                  />
                  <input type="text" placeholder={`Search Workbooks in ${selectedModule} Module`} id="workbook-search" value={searchQuery} autoComplete="off"
                    onChange={(e) => setSearchQuery(e.target.value.toLowerCase())}
                    style={{
                      flex: 1, border: 'none', outline: 'none', fontSize: '13px', padding: '8px 0', backgroundColor: 'transparent', color: '#0000008a'
                    }}
                  />
                </StyledSearchBox>
              </Box>
              <Box display="flex" flexDirection="column">
                <Box display="flex" justifyContent="center" alignItems="center" gap={2}>
                  <Typography variant="caption" sx={{ fontSize: "12px" }}>Show Hidden</Typography>
                  <ShowHideToggle value={showHidden ? "Yes" : "No"} />
                  <Tooltip title="Close" arrow placement="left" slotProps={{
                    tooltip: {
                      sx: { border: "1px solid #ff8000", left: "10px", backgroundColor: "#ffffff", color: "#ff8000", fontSize: "12px", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)" },
                    },
                    arrow: {
                      sx: {
                        color: "#ffffff",
                        '&::before': { content: '""', position: "absolute", width: "100%", height: "100%", border: "1px solid #ff8000" },
                      },
                    }
                  }}>
                    <IconButton size="small" onClick={handleClose} sx={{ color: 'white', zIndex: 3, '&:hover': { backgroundColor: '#fff', color: "red" } }}>
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </Box>
                <Box display="flex">
                  <Typography
                    variant="caption"
                    sx={{ fontSize: "10px", color: "#89939F", alignSelf: "flex-start" }}
                  >
                    {showHidden
                      ? `Showing ${totalHiddenWorkbooksCount} Hidden Workbooks in ${selectedModule} Module`
                      : `${totalHiddenWorkbooksCount} Workbooks hidden in ${selectedModule} Module`}
                  </Typography>

                </Box>
              </Box>
            </Grid>

            {/* List */}
            <Grid item xs={12} sx={{
              padding: '6px', WebkitColumns: '200px', MozColumns: '200px',
              columns: '220px', columnFill: 'auto', columnGap: "10px", flex: 1,
              overflow: state.sidePanelWidth !== 0 ? 'auto' : 'hidden',
              scrollbarWidth: "thin", scrollbarColor: " #ff8000 #13273E", height: "calc(100% - 60px)"
            }}>
              {
                // --- Render Menu ---
                workbookData !== null ? (
                  currentPageData.map((menugroup, index) => {

                    const hiddenGroups = userSettings?.hidden_wb_groups ?? [];
                    const hiddenWorkbooks = userSettings?.hidden_workbooks ?? [];

                    const updatedMenu = {
                      ...menugroup,
                      hidden_by_user: hiddenGroups.includes(menugroup.md_wb_group_id),
                      SAN_Modules_WBGroup_Workbooks: Array.isArray(menugroup.SAN_Modules_WBGroup_Workbooks)
                        ? menugroup.SAN_Modules_WBGroup_Workbooks.map((w) => ({
                          ...w,
                          hidden_by_user: hiddenWorkbooks.includes(w.workbook_id),
                        }))
                        : [],
                    };

                    const visibleWorkbooks = getVisibleChildMenu(updatedMenu);
                    const filteredWorkbooks = visibleWorkbooks.filter((childMenu) => childMenu.workbook_title.toLowerCase().includes(searchQuery));

                    if (filteredWorkbooks.length === 0) return null;

                    const highlightMatch = (text, query) => {
                      if (!query) return text;
                      const escapeRegex = (string) => string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
                      const safeQuery = escapeRegex(query);
                      const regex = new RegExp(`(${safeQuery})`, "gi");
                      return text.split(regex).map((part, i) =>
                        regex.test(part) ? (
                          <span key={i} style={{ color: '#ff8000', fontWeight: 'bold' }}>{part}</span>
                        ) : (
                          part
                        )
                      );
                    };

                    return (
                      <List component="ul" style={{
                        padding: "8px", marginBottom: updatedMenu.hidden_by_user ? "12px" : "2px", backgroundColor: updatedMenu.hidden_by_user ? '#193350' : 'inherit', color: '#FF8000',
                        borderRadius: "20px", marginInline: "4px",
                        '-webkit-column-break-inside': 'avoid', 'page-break-inside': 'avoid', breakInside: 'avoid',
                      }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            position: "relative",
                            "&:hover .visibility-icon": {
                              visibility: "visible",
                            },
                          }}
                        >
                          {/* Workbook group title */}
                          {menugroup.SAN_WorkbookGroups[0].wb_group_description !== null ? (
                            <>
                              <ListItemText
                                onMouseMove={(e) => {
                                  setTooltip({
                                    visible: true, text: menugroup.SAN_WorkbookGroups[0].wb_group_description,
                                    x: e.clientX, y: e.clientY,
                                  });
                                }}
                                onMouseLeave={handleMouseLeave}
                                primary={menugroup.wb_group_title}
                                primaryTypographyProps={{ sx: { fontSize: "13px", padding: 0, opacity: updatedMenu.hidden_by_user ? 0.4 : 1, textAlign: "left" } }}
                              />
                              {tooltip.visible && (
                                <div
                                  style={{
                                    position: "fixed", top: tooltip.y + 20, left: tooltip.x + 12,
                                    pointerEvents: "none", background: "#193350", zIndex: 999,
                                    color: "#B5B7B7", padding: "4px 8px", borderRadius: 4, fontSize: 11,
                                  }}
                                >
                                  {tooltip.text}
                                </div>
                              )}
                            </>
                          ) : (
                            <ListItemText
                              primary={menugroup.wb_group_title}
                              primaryTypographyProps={{ sx: { fontSize: "13px", padding: 0, opacity: updatedMenu.hidden_by_user ? 0.4 : 1, textAlign: "left" } }}
                            />
                          )}
                        </Box>

                        {/* Workbook list */}
                        {filteredWorkbooks.map((childMenu) => {
                          const checkWorkbook = workbookKeys.includes(childMenu.workbook_id.toString());

                          if (!checkWorkbook) {
                            return (
                              <ListItem key={childMenu.workbook_id} disablePadding sx={{
                                padding: 0, color: "#fff", textWrap: "auto", breakInside: "avoid"
                              }}>
                                <ListItemButton
                                  sx={{
                                    padding: "0 6px",
                                    borderRadius: 50,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.5,
                                    marginBottom: childMenu.hidden_by_user ? "2px" : "0px",
                                    '&:hover': {
                                      backgroundColor: '#fff5eb',
                                      '& .MuiListItemText-root': { color: "#ff8000" },
                                      '& .visibilityIcon': { visibility: "visible" },
                                    },
                                    backgroundColor: childMenu.hidden_by_user ? "#193350" : "inherit"
                                  }}
                                  onClick={() => handleClose(childMenu.workbook)}
                                >
                                  {childMenu.workbook.workbook_description !== null ? (
                                    <>
                                      <ListItemText
                                        onMouseMove={(e) => {
                                          setTooltip({
                                            visible: true, text: childMenu.workbook.workbook_description,
                                            x: e.clientX, y: e.clientY,
                                          });
                                        }}
                                        onMouseLeave={handleMouseLeave}
                                        sx={listText}
                                        primary={highlightMatch(childMenu.workbook_title, searchQuery)}
                                        primaryTypographyProps={{
                                          sx: {
                                            fontSize: "13px", padding: 0,
                                            opacity: (updatedMenu.hidden_by_user || childMenu.hidden_by_user) ? 0.4 : 1
                                          }
                                        }}
                                      />
                                      {tooltip.visible && (
                                        <div
                                          style={{
                                            position: "fixed", top: tooltip.y + 20, left: tooltip.x + 12,
                                            pointerEvents: "none", background: "#193350", zIndex: 999,
                                            color: "#B5B7B7", padding: "4px 8px", borderRadius: 4, fontSize: 11,
                                          }}
                                        >
                                          {tooltip.text}
                                        </div>
                                      )}
                                    </>
                                  ) : (
                                    <ListItemText
                                      sx={listText}
                                      primary={highlightMatch(childMenu.workbook_title, searchQuery)}
                                      primaryTypographyProps={{
                                        sx: {
                                          fontSize: "13px", padding: 0,
                                          opacity: (updatedMenu.hidden_by_user || childMenu.hidden_by_user) ? 0.4 : 1
                                        }
                                      }}
                                    />
                                  )}
                                </ListItemButton>
                              </ListItem>
                            );
                          }
                        })}
                      </List>
                    )
                  })
                ) : null}
            </Grid>
          </Grid>
        </Slide>
      </ClickAwayListener>
    </>
  );
};

export default MegaMenu;
